export interface HistoricalInterface {
  attributes: {
    category: string;
    device: {
      deviceId: string;
      deviceType: string;
    };
    timestamp: number;
    level?: string;
  };
  id: string;
  type: string;
}
